<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">查看预览详情</h1>
            <div class="tips-wrapper clearfix">
                <div class="small-title">生成条件</div>
                <div class="field-content">
                    <div>每个站点选取楼盘数：{{preDetail.house_num}}</div>
                    <div>每个楼盘新增问答数：{{preDetail.asks_num}}</div>
                    <div>销售状态：{{saleInfo}}</div>
                    <div>审核状态： {{statusVerify}}</div>
                    <div>生成时间段： {{preDetail.start_time + ' - '+ preDetail.end_time}}</div>
                </div>
                <div class="small-title">
                    <span>站点生成预估</span>
                    <span class="hint">(预览情况仅供参考，可能与实际生成情况存在差异)</span>
                </div>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="site_name" label="站点" width="180"></el-table-column>
                    <el-table-column prop="conform_house_num" label="符合条件楼盘数" width="180"></el-table-column>
                    <el-table-column prop="create_num" label="预估生成量"></el-table-column>
                </el-table>
            </div>
        </div>
        <div class="align-center">
            <el-button @click="hideMenu">取消</el-button>
            <el-button type="primary" @click="submitForm()">按此任务生成</el-button>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { parseTime } from '@/utils'
import {addTopicTask } from '@/service/topicBank'

export default {
    name: 'add',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
        preDetail:Object
    },
    data () {
        return {
            tableData:[],
        }
    },
    computed:{
        saleInfo(){
            if(this.preDetail.sale_info == 0){
                return "不限"
            }else if(this.preDetail.sale_info == 1){
                return "在售"
            }else if(this.preDetail.sale_info == 2){
                return "待售"
            }else if(this.preDetail.sale_info == 3){
                return "售完"
            }else if(this.preDetail.sale_info == 4){
                return "尾盘"
            }
        },
        statusVerify(){
            if(this.preDetail.status_verify == 1){
                return "需要审核"
            }else if(this.preDetail.status_verify == 2){
                return "无需审核"
            }
        }
    },
    watch: {
        preDetail:{
            handler(newVal){
                this.tableData = [newVal]
            }
        }
    },

    mounted(){
        
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
         
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
        },
        submitForm () {
            let query = {
                site_id_str:this.preDetail.site_id + "",
                house_num:this.preDetail.house_num,
                asks_num:this.preDetail.asks_num,
                sale_info:this.preDetail.sale_info,
                status_verify:this.preDetail.status_verify,
                create_time_period_start:this.preDetail.created_at,
                create_time_period_end:this.preDetail.end_time,
                house_id:this.preDetail.house_id,
                type:this.preDetail.type
            };
            addTopicTask(query).then((data) => {
                this.$message({
                    message: '添加成功',
                    type: 'success',
                    duration: 3 * 1000
                })
                this.hideMenu()
                this.callback && this.callback();
            }).catch(err => {
                this.$message({
                    message: err.message || '添加失败',
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
    }
}
</script>
<style scoped>
.tips-wrapper{
    width: 100%;
    margin:20px 0;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}

.tips-wrapper .small-title{
    color: #1f1f1f;
    font-size: 16px;
    line-height: 25px;
    font-weight: bold;
    margin-bottom: 10px;
}
.tips-wrapper .small-title .hint{
    color: red;
    margin-left: 10px;
}
.tips-wrapper .field-content div{
    line-height: 30px;
}
</style>